import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SET_UNIT_DETAILS,
  USER_MENU_DETAILS_REQUEST, 
  USER_MENU_DETAILS_SUCCESS, 
  USER_MENU_DETAILS_FAILURE, 
  NOTIFICATION_REQUEST,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_FAILURE,
  REFRESH_SESSION,
  REFRESH_SESSION_SUCCESS,
  REFRESH_SESSION_FAILURE
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  unitDetails: [],
  isAuthenticated: !!localStorage.getItem("authUser"),
  logoutReason:null,
  notificationList: [],
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        logoutReason:null,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        user:action.payload,
        isAuthenticated: true
      }
      break
    case LOGOUT_USER:
      state = { ...state,isAuthenticated: false,logoutReason: action.payload.reason,unitDetails: [] }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case USER_MENU_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case USER_MENU_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
      };
    case USER_MENU_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SET_UNIT_DETAILS: // Handle SET_UNIT_DETAILS action
      return {
        ...state,
        unitDetails: action.payload || [],
      };
    case NOTIFICATION_REQUEST:
      return { ...state, loading: true, error: null };

    case NOTIFICATION_SUCCESS:
      return { ...state, loading: false, notificationList: action.payload };

    case NOTIFICATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    
    case REFRESH_SESSION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case REFRESH_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.token, 
        error: null,
      };
    case REFRESH_SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error, 
      };
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
